<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center"><em>For lovely Aunt Bebe Sell,<br/>still reading and still enjoying<br/>at the age of ninety-two</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312364496_epub_ded_r1.vue?6d2d5a5b